const Service = (type, action) => {
	let parsed = null;

	switch (type) {
		case "SEARCH": {
			parsed = { type: "GET", url: `/api/user/?${action.queryString}` };
			break;
		}

		case "SEARCH_SELECTION": {
			parsed = {
				type: "GET",
				url: `/api/user/${action.userSelectionObjectId}/?${action.queryString}`,
			};
			break;
		}

		case "GETALL": {
			parsed = { type: "GET", url: "/api/v0.1/users/" };
			break;
		}

		case "GETONE": {
			parsed = { type: "GET", url: `/api/v0.1/users/${action.userId}/` };
			break;
		}

		default:
			break;
	}

	return parsed;
};

export default Service;
